/**
 * 圓形圖示按鈕的 class 組合。
 *
 * IconButton 是主要使用者；但 MediaToolbar 的上傳鍵必須是包著 <input type="file"> 的
 * <label>，無法改用 IconButton，外觀卻要一致，因此把 class 字串抽出來共用，
 * 避免兩邊各寫一份而走鐘。（獨立檔案：從 IconButton.jsx 匯出會破壞它的 fast refresh）
 *
 * 停用態的灰色與 cursor 定義在 general.scss 的 .icon-btn-disabled。
 *
 * @param {{size?: 'sm'|'md'|'lg', disabled?: boolean, className?: string}} options
 * @returns {string}
 */
export const iconBtnClass = ({ size = 'md', disabled = false, className } = {}) =>
  `d-inline-flex align-items-center justify-content-center rounded-circle flex-shrink-0 icon-btn icon-btn-${size}${disabled ? ' icon-btn-disabled' : ''}${className ? ` ${className}` : ''}`;
